import React, {useState} from 'react'
import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {RegionConfigTable} from '../../../_metronic/partials/widgets/tables/RegionConfigTable'
import {useNavigate} from 'react-router-dom'
import CreateRegionConfigurations from './CreateRegionConfigurations'
import axios from 'axios'
import UpdateRegionConfigurations from './UpdateRegionConfigurations'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: '',
    path: '',
    isSeparator: false,
    isActive: false,
  },
]

const RegionConfigPage = () => {
  const [showCreatePopUp, setShowCreatePopUp] = useState(false)
  const [showUpdatePopUp, setShowUpdatePopUp] = useState(false)
  const [allRegions, setAllRegions] = useState(null)
  const [updateConfig, setUpdateConfig] = useState(null)
  const [allConfigs, setAllConfigs] = useState<any>(null)
  const navigate = useNavigate()
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  // const getAllRegions = async () => {
  //   const allRegions = await axios.post(
  //     `${process.env.REACT_APP_BACKEND_BASEURL}/region/getAllRegion/`,
  //     {}
  //   )
  //   if (allRegions.data?.status == 'SUCCESS') {
  //     setAllRegions(allRegions.data.data)
  //   }
  // }

  const getAllConfigs = async () => {
    const allRegions = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/config/getAllConfig/`,
      {}
    )
    if (allRegions.data?.status == 'SUCCESS') {
      const tempAllConfig: any = []
      allRegions.data.data.map((config: any) => {
        tempAllConfig.push({
          ...config,
          configuration: JSON.parse(config.configuration),
        })
      })

      setAllConfigs(tempAllConfig)
    }
  }

  useEffect(() => {
    // getAllRegions()
    getAllConfigs()
  }, [])

  const handleCreateButtonClick = () => {
    setShowCreatePopUp(!showCreatePopUp)
    setShowUpdatePopUp(false)
    // navigate('/createregionconfig')
  }

  const handleApplyClick = async (values: any) => {
    const config = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/config/createConfig/`,
      values
    )
    if (config.data?.status == 'SUCCESS') {
      getAllConfigs()
      setShowCreatePopUp(false)
    }
  }

  const onApplyUpdate = async (configuration: any) => {
    const config = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/config/updateConfig/`,
      configuration
    )
    if (config.data?.status == 'SUCCESS') {
      getAllConfigs()
      handleCloseUpdate()
    }
  }

  const handleUpdatePopup = (configuration: any) => {
    setUpdateConfig(configuration)
    setShowCreatePopUp(false)
    setShowUpdatePopUp(!showUpdatePopUp)
  }

  const handleCloseUpdate = () => {
    setShowUpdatePopUp(false)
  }

  return (
    <>
      <div className='text-end pb-2'>
        {/* <button
          type='button'
          className='btn btn-outline btn-outline-primary rounded-1 btn-sm  me-2'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='top-end'
          onClick={handleCreateButtonClick}
        >
          <span className=''>Create</span>
        </button> */}
        {/* {showCreatePopUp ? (
          <CreateRegionConfigurations
            type='regionConfig'
            onApplyClick={handleApplyClick}
            setShowCreatePopUp={setShowCreatePopUp}
            allRegions={allRegions}
          />
        ) : (
          <></>
        )} */}

        {/* {showUpdatePopUp ? (
          <UpdateRegionConfigurations
            type='regionConfig'
            onApplyUpdate={onApplyUpdate}
            allRegions={allRegions}
            updateConfig={updateConfig}
            handleCloseUpdate={handleCloseUpdate}
          />
        ) : (
          ''
        )} */}
      </div>

      <div>
        <RegionConfigTable allConfigs={allConfigs} />
      </div>
    </>
  )
}

const RegionConfigWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({id: 'Region Configurations'})}
      </PageTitle>
      <RegionConfigPage />
    </>
  )
}

export default RegionConfigWrapper
